<template>
  <div>
    <load v-if="loadingTipo" mode="table" />
    <div v-else>
      <div class="col-12 px-0">
        <div class="d-flex align-items-center justify-content-between mb-0">
          <div>
            <h5 class="font-weight-bold">Tipos de {{ tipo }}</h5>
          </div>

          <div>
            <div class="input-group mb-3">
              <b-input
                :placeholder="$t('Type to search')"
                class="form-control search-input"
                type="search"
                v-model="search"
                v-on:change="getListTipos"
                aria-describedby="input-search"
              />
              <div class="input-group-append" role="button">
                <span class="input-group-text" id="input-search"
                  ><i class="fas fa-search search-icon"
                /></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-md-12 alert alert-info alert-dismissible fade show"
        role="alert"
        v-if="TipoList.length > 0"
      >
        <strong>Atenção!</strong> você poderá inserir um <b>novo tipo</b>, ou selecionar um existente, e logo em seguida inserir seu <b>subtipo</b>.
        <ul>
          <li>
            Para inserir basta digitar a <b>descrição</b> no campo de selecionar
            a opção e depois apertar para inserir.
          </li>
          <li>Tipos utilizados são contabilizados e não podem ser apagados.</li>
          <li>
            Você poderá gerenciar os subtipos selecionando uma tipo na tabela.
          </li>
          <li>Os tipos padrões do sistema não podem ser excluídos.</li>
        </ul>
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="row" v-if="TipoList.length > 0">
        <form-select-input
          v-model="new_tipo"
          grid="6"
          label="Tipo"
          :itens="tipos"
          placeholder="Selecione ou digite um tipo"
          @insert="inserirTipo"
          @input="getSubTipos"
          :uppercase="tipo != 'Metas' ? true : false"
        />
        <form-select-input
          :disabled="loadSubtipo"
          v-model="new_subtipo"
          grid="6"
          label="Subtipo"
          placeholder="Selecione um tipo antes"
          :itens="subtipos"
          @insert="inserirSubtipo"
          @input="getSubTipos"
          :uppercase="tipo != 'Metas' ? true : false"
        />
      </div>
      <div class="row">
        <div class="col-12">
          <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
          />
          <b-table
            :fields="[
              {
                key: 'id',
                label: $t('ID'),
              },
              {
                key: 'descricao',
                label: $t('Nome'),
              },
              {
                key: 'origem',
                label: $t('Origem'),
              },
              {
                key: 'contagem',
                label: $t('Contagem'),
              },
              {
                key: 'actions',
                label: '',
                class: 'text-right',
                thStyle: { width: '95px', minWidth: '95px' },
              },
            ]"
            :items="TipoList"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="md"
            table-class="mb-3"
          >
            <template v-slot:cell(id)="data">
              {{ data.item.id }}
            </template>
            <template v-slot:cell(descricao)="data">
              {{ data.item.descricao }}
            </template>
            <template v-slot:cell(origem)="data">
              {{ data.item.origem }}
            </template>
            <template v-slot:cell(contagem)="data">
              {{ data.item.contagem }}
            </template>
            <template v-slot:cell()="data">
              <b-button
                :title="$t('Gerenciar')"
                @click="
                  $bvModal.show('show-subtipos');
                  TipoSelected = data.item;
                "
                class="px-2 mb-0"
                size="xs"
                type="button"
                v-b-tooltip.hover
                variant="success"
              >
                <i class="mdi mdi-square-edit-outline" />
              </b-button>
              <b-button
                v-if="data.item.origem == 'CADASTRADO'"
                @click="excluir(data.item)"
                class="px-2 mb-0"
                size="xs"
                type="button"
                v-b-tooltip.hover
                variant="danger"
                ><i class="mdi mdi-delete" />
              </b-button>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />
                <h3 class="bold">{{ $t("No records found") }}</h3>
              </div>
            </template>
          </b-table>

          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  @change="getListTipos"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }} {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>
        </div>
        <router-view />
      </div>
      <ModalSubTipos
        :item="TipoSelected"
        :modulo="modulo"
        @reload="getListTipos"
      />
    </div>
  </div>
</template>
<script>
import ModalSubTipos from "./ModalSubTipos";
export default {
  components: { ModalSubTipos },
  props: ["tipo", "modulo", "model"],
  name: "Tipo",
  data() {
    return {
      loadingTipo: true,
      loadSubtipo: true,
      TipoSelected: "",
      TipoList: [],
      SubTipoList: {},
      new_tipo: null,
      new_subtipo: null,
      tipos: [],
      subtipos: [],
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  watch: {
    tipo(n, o) {
      this.getListTipos();
      this.new_tipo = null;
      this.new_subtipo = null;
    },
  },
  mounted() {
    this.getListTipos();
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getListTipos();
      }
    },
    getListTipos() {
      this.loading = true;
      this.loadingTipo = true;
      this.geTipos();
      axios
        .post("api/dashboard/admin/list/tipos", {
          model: this.model || this.modulo,
          module: this.modulo,
          page: this.page,
          search: this.search,
          perPage: this.perPage,
        })
        .then((response) => {
          this.TipoList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getListTipos();
          } else {
            this.loading = false;
          }
        })
        .finally(() => {
          this.loadingTipo = false;
        });
    },
    geTipos() {
      axios
        .post("api/dashboard/admin/getTipos", {
          model: this.model || this.modulo,
          module: this.modulo,
        })
        .then((response) => {
          this.setTipos(response.data.data);
        });
    },
    getSubTipos(tipo) {
      this.loadSubtipo = true;
      axios
        .post("api/dashboard/admin/getTipos", {
          tipo_pai: tipo,
          model: this.model || this.modulo,
          module: this.modulo,
        })
        .then((response) => {
          this.setSubTipos(response.data.data);
        })
        .finally(() => {
          this.loadSubtipo = false;
        });
    },
    setTipos(data) {
      this.tipos = data.map((elem) => ({
        id: elem.id,
        value: elem.descricao,
      }));
    },
    setSubTipos(data) {
      this.SubTipoList = data;
      this.subtipos = data.map((elem) => ({
        id: elem.id,
        value: elem.descricao,
      }));
    },
    inserirTipo(tipo) {
      this.loading = true;

      if (this.tipo != "Metas") {
        tipo = tipo.toUpperCase();
      }

      axios
        .post("api/dashboard/admin/tipos", {
          descricao: tipo,
          model: this.model || this.modulo,
          module: this.modulo,
        })
        .then((response) => {
          this.getListTipos();
          this.$snack.success({
            button: false,
            text: "Tipo cadastrado com sucesso.",
          });
          this.setTipos(response.data.data);

          this.loading = false;
        });
    },
    inserirSubtipo(sub) {
      if (this.tipo != "Metas") {
        sub = sub.toUpperCase();
      }
      axios
        .post("api/dashboard/admin/tipos", {
          descricao: sub,
          tipo_pai: this.new_tipo,
          model: this.model || this.modulo,
          module: this.modulo,
        })
        .then((response) => {
          this.$snack.success({
            button: false,
            text: "Subtipo cadastrado com sucesso.",
          });
          this.setSubTipos(response.data.data);
          this.getListTipos();
        });
    },
    excluir(item) {
      axios
        .get(`api/dashboard/admin/excluir/tipo/${item.id}/${this.modulo}`)
        .then((response) => {
          this.getListTipos();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        });
    },
  },
};
</script>
<style lang="css">
.list-group-item-action {
  cursor: pointer;
}
</style>
